export const formatNumberWithCommas: (value: string | number | undefined) => string = (value) =>
    value != null ? `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '';

export const parseNumberWithCommas: (value: string | undefined) => number = (value = '') =>
    value != null ? Number.parseInt(value.replace(/\$\s?|(,*)/g, '')) : 0;
